export const ENDPOINTS = {
  //employees
  EMPLOYEES: "/api/employee",
  EMPLOYEE_LOGIN: "/api/employee/login",
  EMPLOYEE_SET_PASSWORD: "/api/employee/set-password",

  //roles
  ROLES: "/api/role",

  //company
  COMPANY: "/api/company",
  COMPANY_LOGIN: "/api/company/login",
  COMPANY_ROLES: "/api/company/roles",
  COMPANY_SET_PASSWORD: "/api/company/set-password",

  //super-admin
  SUPER_ADMIN_LOGIN: "api/super-admin/login",

  //service-requests
  SERVICE_REQUESTS: "/api/service-requests",

  //product-requests
  PRODUCT_REQUESTS: "/api/rent-requests",

  // user
  USER: "/api/user/",

  //payments
  PAYMENTS: "/api/payments",
};
